import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { CopyTemplate } from '../../models/CopyTemplate';
import { Template } from '../../models/Template';
import { IAccount } from '@account-users';

@Component({
  selector: 'app-copy-template-form',
  templateUrl: './copy-template-form.component.html',
  styleUrls: ['./copy-template-form.component.scss'],
})
export class CopyTemplateFormComponent implements OnInit {
  @Input() accounts: IAccount[] = [];
  @Input()
  set templates(templates: Template[]) {
    this.sortedTemplates = [
      ...templates,
    ].sort(({ name: aName }, { name: bName }) =>
      (aName || '').toLowerCase() > (bName || '').toLowerCase() ? 1 : -1,
    );
  }
  @Input() copyTemplateError: HttpErrorResponse;
  @Output() fetchTemplates = new EventEmitter<string>();
  @Output() copyTemplate = new EventEmitter<CopyTemplate>();

  form: FormGroup;
  filterFromAccount = '';
  filterToAccount = '';
  sortedTemplates: Template[] = [];

  constructor(private fb: FormBuilder) {}

  get fromAccountId() {
    return this.form.get('fromAccountId') as FormControl;
  }

  get templateIds() {
    return this.form.get('templateIds') as FormControl;
  }

  get toAccountId() {
    return this.form.get('toAccountId') as FormControl;
  }

  get fromAccounts() {
    const filter = new RegExp(this.filterFromAccount, 'i');
    return this.accounts.filter((account) =>
      filter.test(`${account.displayName}${account.id}`),
    );
  }

  get toAccounts() {
    const filter = new RegExp(this.filterToAccount, 'i');
    return this.accounts.filter((account) =>
      filter.test(`${account.displayName}${account.id}`),
    );
  }

  ngOnInit() {
    this.form = this.fb.group({
      fromAccountId: this.fb.control('', [Validators.required]),
      templateIds: this.fb.control({ value: [], disabled: true }, [
        Validators.required,
      ]),
      toAccountId: this.fb.control({ value: '', disabled: true }, [
        Validators.required,
      ]),
    });
  }

  onSelectFromAccountId() {
    if (this.fromAccountId.valid) {
      this.fetchTemplates.emit(this.fromAccountId.value);
      this.templateIds.enable();
      this.templateIds.setValue([]);
    }
  }

  onSelectTemplateId() {
    if (this.templateIds.valid) {
      this.toAccountId.enable();
    }
  }

  onSubmit(event: Event) {
    event.preventDefault();
    if (this.form.valid) {
      const copyTemplatePayload: CopyTemplate = {
        templateIds: this.templateIds.value,
        fromAccountId: this.fromAccountId.value,
        toAccountId: this.toAccountId.value,
      };

      this.copyTemplate.emit(copyTemplatePayload);
    }
  }
}
